import AuthContext from "../../utilis/contexts/AuthContext";
import React, {useContext} from "react";
import { Validation} from "../../utilis/tools/validation";
import { Form, Input} from "antd";
import {
    HomeOutlined,
    UserOutlined,
    IdcardOutlined,
    MailOutlined,
    PhoneOutlined,
    MobileOutlined
} from "@ant-design/icons";

type Props = {
    validationSchema: any
    data: any
    notDisable?: Array<string>
    hiddenInputs?: Array<string>
    searchable?:boolean
}
const AuthenticatedForm = ({validationSchema, data,searchable,hiddenInputs=[], notDisable = []}: Props) => {

    const TextArea = Input;

    const authContext = useContext(AuthContext)
    if (!authContext.authenticated) {
        return null
    }


    return <div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <Form.Item
                label="شناسه قبض"
                name="FileNumber"
                initialValue={authContext.currentFileNumber}
                className=""

            >
                <Input disabled size="large" placeholder=""/>
            </Form.Item>
            <Form.Item
                label="شهر"
                name="city"
                initialValue={data.city_name ? data.city_name : ''}
                className=""
            >
                <Input disabled size="large" placeholder=""
                       prefix={<HomeOutlined className="text-gray-50"/>}/>
            </Form.Item>
            {
               data.village && <Form.Item
                    label="روستا"
                    name="village"
                    initialValue={data.village ? data.village : ''}
                    className=""
                >
                    <Input disabled size="large" placeholder=""
                           prefix={<HomeOutlined className="text-gray-50"/>}/>
                </Form.Item>
            }

            <Form.Item
                label="نام"
                name="firstName"
                className=""
                initialValue={data.first_name ? data.first_name : ''}

            >
                <Input disabled={!notDisable.includes('firstName')} size="large" placeholder=""
                       prefix={<UserOutlined className="text-gray-50"/>}/>
            </Form.Item>
            <Form.Item
                label="نام خانوادگی"
                name="lastName"
                initialValue={data.last_name ? data.last_name : ''}
                className=""
            >
                <Input disabled={!notDisable.includes('lastName')} size="large" placeholder=""
                       prefix={<UserOutlined className="text-gray-50"/>}/>
            </Form.Item>
            {!hiddenInputs.includes('tel') &&     <Form.Item
                label="تلفن ثابت"
                name="tel"
                className=""
                rules={[Validation(validationSchema)]}
            >
                <Input size="large" prefix={<PhoneOutlined className="text-gray-50"/>}
                       placeholder="مثلا ۰۱۱۳۵۷۵۵۳۴۳"/>
            </Form.Item>}


            {
                hiddenInputs.length%2===0 &&
                <Form.Item
                    label="تلفن همراه"
                    name="mobile"
                    initialValue={authContext.authenticated ? data.cellphone : ''}
                    rules={[Validation(validationSchema)]}
                    className=""
                >
                    <Input size="large" placeholder="مثلا ۰۹۲۱۰۹۱۳۲۳۲"
                           prefix={<MobileOutlined className="text-gray-50"/>}/>
                </Form.Item>
            }
            {!hiddenInputs.includes('postalCode') && <Form.Item
                label="کد پستی"
                name="postalCode"
                rules={[Validation(validationSchema)]}
                initialValue={data.postal_code}
                className=""
            >
                <Input type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۴۴۱"
                       prefix={<HomeOutlined className="text-gray-50"/>}/>
            </Form.Item>}
            { !searchable&&  !hiddenInputs.includes('postalCode') &&  <Form.Item
                label="کد ملی"
                name="nationalCode"
                rules={[Validation(validationSchema)]}
                initialValue={data.national_code}
                className=""
            >

                    <Input type="tel" size="large" placeholder="مثلا ۴۹۸۰۲۳۴۰۹۶"
                             prefix={<IdcardOutlined className="text-gray-50"/>}/>
            </Form.Item>}

            {!hiddenInputs.includes('email') &&  <Form.Item
                label="ایمیل"
                name="email"
                requiredMark="optional"
                className=""
                initialValue={data.email ? data.email : ''}
                rules={[Validation(validationSchema)]}
            >
                <Input size="large" placeholder="example@gmail.com"
                       prefix={<MailOutlined className="text-gray-50"/>}/>
            </Form.Item>}
            {!searchable&& !hiddenInputs.includes('address') &&  <Form.Item
                label="آدرس"
                name="address"
                initialValue={data.address}
                rules={[Validation(validationSchema)]}
            >
                <TextArea size="large" disabled={!notDisable.includes('address')} placeholder="..."/>
            </Form.Item>}

        </div>
        {hiddenInputs?.length%2===1 &&     <Form.Item
            label="تلفن همراه"
            name="mobile"
            initialValue={authContext.authenticated ? data.cellphone : ''}
            rules={[Validation(validationSchema)]}
            className=""
        >
            <Input size="large" placeholder="مثلا ۰۹۲۱۰۹۱۳۲۳۲"
                   prefix={<MobileOutlined className="text-gray-50"/>}/>
        </Form.Item>}
        {searchable && !hiddenInputs.includes('address') &&   <Form.Item
            label="آدرس"
            name="address"
            initialValue={data.address}

        >
            <TextArea size="large" disabled={!notDisable.includes('address')} placeholder="..."/>
        </Form.Item>}
        {

            hiddenInputs.includes('descrption') &&   <Form.Item
                label="توضحات"
                name="description"
                requiredMark="optional"
                initialValue={data.description}
                rules={[Validation(validationSchema)]}
            >
                <TextArea size="large" placeholder="..."/>
            </Form.Item>
        }

    </div>
}
export default AuthenticatedForm;